import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';

function TabPanel(props) {
  var activeId = props.activeId,
      restProps = _objectWithoutPropertiesLoose(props, ["activeId"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "tabpanel",
    id: activeId + "-panel",
    "aria-labelledby": activeId,
    tabIndex: 0
  }, restProps));
}

export default TabPanel;